import { styled } from '@linaria/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useAvivaSelector } from '@redux/hook'
import { getPolicyNo, sendMailMltc } from '@api/index'
import { find, get } from 'lodash'
import { updatePaymentStatus, updatePolicyNo } from '@redux/slices/MLTC_R3/step5Slice'
import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model'
import { Coverages } from '@models/MLTC/SQSPocketRequest.model'
import { Helpers } from '@utils/helpers'
import { GAAviva } from '@utils/gaAvivaR3'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setLoadingState } from '@redux/slices/loadingSlice'


function PaymentChecking() {
  const history = useHistory();
  const dispatch = useDispatch();

  const quoteRawResponse = useAvivaSelector(state => state.mltcR3Step2.quoteRawResponse);
  const retrieveMyInfo = useAvivaSelector(state => state.mltcR3Step4.retrievedMyInfo);
  const bankId = useAvivaSelector(state => state.mltcR3Step5.bankId);
  const otherBank = useAvivaSelector(state => state.mltcR3Step5.otherBank);
  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail);
  const referenceNo = useAvivaSelector(state => state.mltcR3Step5.referenceNo);

  const [hasError, setHasError] = useState<boolean>(false);
  const [isStatusCheck, setIsStatusCheck] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const analyticUrlParams = useAvivaSelector(state => state.urlAnalytic.param);
  const paramCC = campaignDetail?.campaignCode ? `?cc=${campaignDetail.campaignCode}` : '';
  const analyticParam = Helpers.getUrlAnalyticParams(paramCC !== "", analyticUrlParams);




  const onFailedPayment = useCallback(async (payload: any) => {
    //TODO : create or update slice, for error usage!
    dispatch(setLoadingState(false));
    history.push('/mltc/prepayment?' + paramCC + analyticParam);
  }, [dispatch, hasError, setHasError])

  const trackOnload = ({ errorMessage = '', policyID = '' }): void => {
    const GA = GAAviva.getInstance();
    let { page, acquisition, form } = GA.digitalData;
    page.errorMessage = errorMessage;
    acquisition.product.policyID = policyID;
    form.name = 'Payment';
    GA.trackPageLoad({ page, acquisition, form });
  }
  const onSuccessPayment = useCallback(async (payload: any) => {
    dispatch(setLoadingState(true));
    try {
      const quotation: SQSPocketResponse = new SQSPocketResponse(quoteRawResponse);
      const coverage: Coverages | undefined = find(quotation.coverages, { type: 'P' });
      const response = await getPolicyNo(payload, 3, retrieveMyInfo?.id);
      const policyNo = get(response, 'data');
      dispatch(updatePaymentStatus("successful"));
      dispatch(updatePolicyNo(String(policyNo)));

      trackOnload({ policyID: policyNo });
      sendMailMltc(payload, 3, retrieveMyInfo?.id);
      dispatch(setLoadingState(false));
      history.push('/mltc/thank-you' + paramCC + analyticParam);
    } catch (err) {
      dispatch(setLoadingState(true));
      history.push('/mltc/thank-you' + paramCC + analyticParam);
    }
  }, [dispatch, history, bankId, otherBank, quoteRawResponse, retrieveMyInfo]);

  const checkStatus = useCallback(() => {
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    const status = params.get('status'); //unsuccessful/processing
    console.log('data saved referenceNo', referenceNo, status);
    if (!isStatusCheck) {
      if (referenceNo !== '' && status === 'processing') {
        dispatch(updatePaymentStatus("processing"));
        setIsProcessing(true);
        console.log('is payment success');
        onSuccessPayment(referenceNo);
      } else if (status === 'unsuccessful') {
        dispatch(updatePaymentStatus("unsuccessful"));
        setHasError(true);
        trackOnload({ policyID: referenceNo, errorMessage: 'Payment is unsuccessful' });
        onFailedPayment(referenceNo);
      } else {
        history.push('/mltc/prepayment' + paramCC + analyticParam);
        trackOnload({});
        dispatch(setLoadingState(false));
      }
      setIsStatusCheck(true);
      dispatch(setLoadingState(false));

    }
  }, [referenceNo, onSuccessPayment, setHasError, setIsProcessing, setLoading, otherBank, onFailedPayment, isStatusCheck, dispatch, bankId]);


  useEffect(() => {
    dispatch(setLoadingState(true));
    checkStatus();
  }, []);
  return (
    <Container>
    </Container>
  )
}

export default PaymentChecking

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

const Container = styled.div`
    display: block;
`;

